import LineItem from '@rentivo/gatsby-core/src/containers/PricingProvider/components/PricingDisplay/components/LineItem/component';
export default LineItem;
